<template>
  <section class="footer-container">
    <section class="container">
      <div class="columns">
        <div class="column is-6 has-text-right"><a href="https://www.osfatun.com.ar/"><img class="logo-footer" src="./../../assets/complete-logo-footer.svg" /></a>  </div>
        <div class="column is-6 has-text-left"><a  target="_blank" href="https://www.fatun.org.ar/"><img class="logo-federacion" src="./../../assets/federacion-logo-footer.svg" /></a> </div>
      </div>
      <div class="columns">
        <div class="column is-12 has-text-centered"> <a  target="_blank" href="https://zaro.com.ar"><img class="zaro" src="./../../assets/zaro.svg" width="85" alt="zaro" /></a> </div>
      </div>
    </section>
  </section>
  
</template>

<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-XYP809ZC34"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-XYP809ZC34');
</script>



<script>
  export default {
    name: "LandingFooter",
  };
</script>

<style scoped>
  .footer-container{
    margin-top: 50px;
    padding: 20px 0;
  }
  .zaro{
    margin-top: 50px;
  }

@media screen and (max-width: 42em) {
  .footer-container{ margin-top: 0; overflow: hidden; }
  .zaro{ margin-top:10px;}
  .logo-footer{ display:none; }
  .logo-federacion{ display: block; margin: 0 auto; max-width: 100%;}
}

</style>
